import React, { ReactNode } from 'react';

function CheckMark() {
    return (
        <svg
            viewBox="0 0 13 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute w-4 h-4 right-[-4px] top-0"
        >
            <path
                d="M1 6L4 9.4L12 1"
                stroke="#FBA919"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

interface CheckboxProps {
    isChecked: boolean;
    label: string | ReactNode;
    name?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    helperText?: string;
}

function Checkbox({ isChecked, label, name, onChange, error, helperText }: CheckboxProps) {
    return (
        <div className="space-y-1">
            <label className="inline-flex justify-start items-center cursor-pointer">
                <div className="relative bg-white border rounded-xl border-black w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2">
                    <input
                        type="checkbox"
                        className="opacity-0 absolute cursor-pointer"
                        name={name}
                        checked={isChecked}
                        onChange={onChange}
                    />
                    {isChecked && <CheckMark />}
                </div>
                <div className="select-none leading-4">{label}</div>
            </label>
            {helperText && (
                <div className={`pl-6 text-xs text-left ${error ? 'text-danger' : 'text-secondary'}`}>{helperText}</div>
            )}
        </div>
    );
}

export default Checkbox;
